export default "__VITE_ASSET__vUnW6xz4__"